import { cn } from "@btnet/utilities-core";

import type { AgentTone } from "../searchDialog.types";

/** A count's tint: something overdue reads red, something waiting amber. */
const COUNT_TONE: Record<AgentTone, string> = {
    negative: "bg-surface-error-subtle text-fg-error",
    warning: "bg-surface-warning-subtle text-fg-warning",
    positive: "bg-surface-success-subtle text-fg-success",
    neutral: "bg-surface-neutral-subtle text-fg-secondary",
};

interface ICountPillProps {
    value: number;
    tone: AgentTone;
    testid: string;
}

/**
 * The count behind a suggested question. Not `BTStatusBadge`: its status icon
 * made a bare number read as an error.
 */
export function CountPill({ value, tone, testid }: ICountPillProps) {
    return (
        <span
            className={cn(
                "shrink-0 rounded-full px-2 text-xs font-semibold leading-5 tabular-nums",
                COUNT_TONE[tone],
            )}
            data-testid={testid}
        >
            {value.toLocaleString()}
        </span>
    );
}
